module.exports = [{
      plugin: require('/Users/Jhondge/Documents/Dev/gitlab-projects/fotor-workspace/fotor-website-team/marketing-site/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Fotor","short_name":"Fotor","start_url":"/","icon":"static/favicon.svg"},
    },{
      plugin: require('/Users/Jhondge/Documents/Dev/gitlab-projects/fotor-workspace/fotor-website-team/marketing-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
